import { Image as CapsicumImage } from '@capsicum/common-web';
import { type StaticImageData } from 'next/image';
import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

type ShellProps = PropsWithChildren<{
	cta: JSX.Element;
	image: StaticImageData;
}>;

export const Shell = ({ children, cta, image }: ShellProps) => {
	return (
		<S.Wrapper>
			<S.Slide>
				<S.ImageContainer>
					<S.Image alt="onboarding-slide-image" data-testid="onboarding-slide-image" src={image} />
				</S.ImageContainer>

				<S.ContentContainer>
					<S.Content>{children}</S.Content>

					<div>{cta}</div>
				</S.ContentContainer>
			</S.Slide>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		height: 100%;
		display: flex;
		justify-content: center;
	`;

	export const Slide = styled.div`
		height: 100%;
		display: flex;
		flex: 0 1 400px;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxlarge};
		padding-top: ${({ theme }) => theme.spacings.large};
		padding-left: ${({ theme }) => theme.spacings.small};
		padding-right: ${({ theme }) => theme.spacings.small};
		padding-bottom: ${({ theme }) => theme.spacings.xlarge};
	`;

	export const ImageContainer = styled.div`
		flex: 1;
		width: 100%;
		position: relative;
	`;

	export const ContentContainer = styled.div`
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxlarge};
	`;

	export const Content = styled.div`
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const Image = styled(CapsicumImage)`
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: contain;
	`;
}
